import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework'
import '@mdi/font/css/materialdesignicons.css'


Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // Definuj ikonový font MDI
  },
  theme: {
    themes: {
      light: {
        primary: '#7B1FA2', // napr. purple darken-2
      },
      dark: {
        primary: '#BB86FC',
      },
    },
  },
})
